import {resolvePublicApiUrl} from '#shared/utils/apiUrl';

export function useApiUrl() {
	const config = useRuntimeConfig();
	return resolvePublicApiUrl(config.public.apiUrl, config.public.apiUrlSSR);
}
